import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const AddSiblingRedux = createActions(
  {
    addSiblingRequest: ['studentId', 'data'],
    addSiblingSuccess: ['data'],
    addSiblingFailure: ['errors'],
  },
  {
    prefix: 'ADD_SIBLING_',
    defaultActions: {
    },
  },
)

const { Types, Creators } = AddSiblingRedux
export const AddSiblingTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
})

/* ------------- Reducers ------------- */

const addSiblingRequest = state => state.merge({
  sending: {
    fetching: true,
    error: null,
  },
  addSibling: {
    error: '',
    success: false,
  },
}, d)

const addSiblingSuccess = (state, { data }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  addSibling: {
    error: '',
    success: true,
  },
  ...data,
}, d)

const addSiblingFailure = (state, { errors }) => state.merge({
  sending: {
    fetching: false,
    error: errors,
  },
  addSibling: {
    success: false,
    error: errors[0],
  },
}, d)


export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.addSiblingRequest]: addSiblingRequest,
    [Types.addSiblingSuccess]: addSiblingSuccess,
    [Types.addSiblingFailure]: addSiblingFailure,
  },
  {
    defaultActions: {
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/AddSiblingRedux.js